import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { COUPON_FETCH } from "../actions/types";
import { couponFetchSuccess } from "../actions/CouponActions";
import axios from "axios";
import axiosRetry from 'axios-retry';
import { push } from "connected-react-router";
import { values } from "lodash";
import { compose } from "redux";
import moment from "moment";
const ENDUSER_BOARD_ID = 1041321766;
axiosRetry(axios, {
	retries: 3, retryDelay: (retryCount) => {
		return retryCount * 1000;
	}
});

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;

// API
const couponFetchRequest = async payload => {
	// return await axios
	// 	.post(`${REACT_APP_API_URL}/monday/coupon/`, payload, {})
	// 	.then(response => response.data)
	// 	.catch(error => {
	// 		throw error;
	// 	});
 
	const data = await axios.get(`https://automation.rewrds.me/webhook/8c846b94-678f-4364-8a95-eb57118a6269/${payload}`)
	.catch(err => {
		console.error(err.data)
	})
	.then((res) => {
		return res.data.data.items_by_column_values[0]
	});
	
	if(data){
		return data;
	}else{
		return false;
	}

};





function destructureCoupon(data){
	let newPayload = {};
	data.column_values.map( Item => {
		newPayload[`${Item.id}`] = Item.text
	})
	return newPayload;
}
// WORKER
function* couponFetch({ payload }) {
	try {
		let data = yield call(couponFetchRequest, payload);
		if(!data){
			yield put(push('/notfound'));
			return false;
		}
		let _coupon = destructureCoupon(data);		
		let couponData = {
			item_id : _coupon.item_id,
			coupon_code: _coupon.text9,
			name: _coupon.text6,
			corporate_image:_coupon.text8,
			partner_logo: _coupon.text0,
			coupon_image: _coupon.text65,
			description: _coupon.long_text,
			term_condition: _coupon.long_text5,
			branch: _coupon.long_text3,
			status:_coupon.status,
			enable:_coupon.status5,
			start_date: _coupon.date4,
			expire_date: _coupon.date,


			theme_color:_coupon.text68,
			header_text_color:_coupon.text69,
			font_text_color:_coupon.text1,
			tab_color_active:_coupon.text88,
			tab_font_color_active:_coupon.text10,

		}
		if(couponData.status!=="AVALIABLE"){
			yield put(push('/notfound'));
			return false;
		}

		if(couponData.start_date){
			let is_start = moment(couponData.start_date).diff(moment(new Date()), "seconds");
			if (is_start >= 0) {
				yield put(push('/notfound'));
				return false;
			}
		}
		if(couponData.expire_date){
			let expired_datetime = ""
			if(couponData.expire_date.includes(":")){
				expired_datetime  = couponData.expire_date
			}else{
				expired_datetime  = couponData.expire_date + " 23:59"
			}
			let is_expired = moment(expired_datetime).add(1, 'minute').diff(moment(new Date()), "seconds");
		 
			if (is_expired < 0) {
				yield put(push('/expired'));
				return false;
			}
		}

		if(couponData.theme_color){

			document.body.style.setProperty('--bg-color',couponData.theme_color);
			document.body.style.setProperty('--header-text-color',couponData.header_text_color);

			document.body.style.setProperty('--primary-color',couponData.font_text_color);
			document.body.style.setProperty('--second-color',couponData.font_text_color);

			document.body.style.setProperty('--tab-bg-color-active',couponData.tab_color_active);
			document.body.style.setProperty('--tab-font-color-active',couponData.tab_font_color_active);
		}

		yield put(couponFetchSuccess(couponData));

	} catch(er)
	{ 
		console.error(er)
	}
}


// WATCHER
function* couponFetchWatcher() {
	yield takeEvery(COUPON_FETCH, couponFetch);

}

export default function* rootSaga() {
	yield all([fork(couponFetchWatcher)]);
}
